import * as actions from './actions';
import * as model from './model';
import * as selectors from './selectors';
import reducer from './reducer';

export { actions, model, selectors };
export default reducer;
